import React from "react"
// import rootComponent from "../index.jsx"
// import HomeView from "home"
export class HomeView extends React.Component {
	componentDidMount () {
		window.location.replace(`https://winpeforum.com/connect`)
	}
	render () {
		// // console.log("this.props", this.props)
		return (
			<div></div>
		)
	}
}

export default HomeView



// WEBPACK FOOTER //
// ./src/pages/connect/index.js